/* =========================================================
   QUBITHEME — Theme JS
   Side menu, slot machine, image crossfade
   ========================================================= */

// === SIDE MENU ===
function toggleSideMenu(open) {
  const drawer = document.getElementById('side-menu-drawer');
  const overlay = document.getElementById('side-menu-overlay');
  if (!drawer || !overlay) return;

  if (open) {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('side-menu-open');
    document.body.style.overflow = 'hidden';
  } else {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('side-menu-open');
    document.body.style.overflow = '';
  }
}

function handleHamburgerClick() {
  const isOpen = document.body.classList.contains('side-menu-open');
  toggleSideMenu(!isOpen);
}

// === IMAGE CROSSFADE (Homepage / Collection grids) ===
function initProductCardSliders() {
  // Delegate navigation buttons click
  document.addEventListener('click', function(e) {
    var prevBtn = e.target.closest('[data-arrow-prev]');
    var nextBtn = e.target.closest('[data-arrow-next]');
    
    if (!prevBtn && !nextBtn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    var btn = prevBtn || nextBtn;
    var card = btn.closest('[data-product-card]');
    if (!card) return;
    
    var images = card.querySelectorAll('.product-card__img');
    if (images.length <= 1) return;
    
    // Find active image index
    var activeIdx = 0;
    images.forEach(function(img, idx) {
      if (img.classList.contains('is-active')) {
        activeIdx = idx;
      }
    });
    
    // Hide current active image
    images[activeIdx].classList.remove('is-active');
    images[activeIdx].style.opacity = '0';
    
    // Calculate new index
    var newIdx = activeIdx;
    if (prevBtn) {
      newIdx = (activeIdx - 1 + images.length) % images.length;
    } else {
      newIdx = (activeIdx + 1) % images.length;
    }
    
    // Show new active image
    images[newIdx].classList.add('is-active');
    images[newIdx].style.opacity = '1';
  });
}

// === SLOT MACHINE ===
var isSpinning = false;

function spinSlotMachine() {
  if (isSpinning) return;
  isSpinning = true;

  var btn = document.getElementById('slot-spin-btn');
  if (btn) {
    btn.disabled = true;
    btn.innerText = 'GIRANDO...';
  }

  var containers = [
    document.getElementById('slot-img-container-1'),
    document.getElementById('slot-img-container-2'),
    document.getElementById('slot-img-container-3')
  ];
  var images = [
    document.getElementById('slot-img-1'),
    document.getElementById('slot-img-2'),
    document.getElementById('slot-img-3')
  ];

  // Gather product data from slot items
  var slotDataElements = document.querySelectorAll('[data-slot-product]');
  var slotProducts = [];
  slotDataElements.forEach(function(el) {
    try {
      slotProducts.push(JSON.parse(el.getAttribute('data-slot-product')));
    } catch(e) {}
  });

  if (slotProducts.length < 3) return;

  // Add blur
  containers.forEach(function(c) { if (c) c.style.filter = 'blur(2px)'; });

  // Rapid image swaps
  var spinIntervals = [];
  images.forEach(function(img) {
    var interval = setInterval(function() {
      var rand = slotProducts[Math.floor(Math.random() * slotProducts.length)];
      if (img) img.src = rand.image;
    }, 80);
    spinIntervals.push(interval);
  });

  // Select 3 unique random products
  var selected = [];
  var available = slotProducts.slice();
  while (selected.length < 3 && available.length > 0) {
    var idx = Math.floor(Math.random() * available.length);
    selected.push(available.splice(idx, 1)[0]);
  }

  // Stop slots sequentially
  selected.forEach(function(product, index) {
    setTimeout(function() {
      clearInterval(spinIntervals[index]);
      if (images[index]) images[index].src = product.image;
      if (containers[index]) containers[index].style.filter = '';

      var titleEl = document.getElementById('slot-title-' + (index + 1));
      var priceEl = document.getElementById('slot-price-' + (index + 1));
      var linkEl = document.getElementById('slot-btn-' + (index + 1));
      var itemEl = document.getElementById('slot-item-' + (index + 1));

      if (titleEl) titleEl.innerText = product.title;
      if (priceEl) priceEl.innerText = product.price;
      if (itemEl && product.id) itemEl.setAttribute('data-variant-id', product.id);
      if (linkEl) {
        linkEl.style.display = 'inline';
        linkEl.href = product.url;
      }

      if (index === 2) {
        isSpinning = false;
        if (btn) {
          btn.disabled = false;
          btn.innerText = btn.getAttribute('data-spin-text') || 'Gioca';
        }
      }
    }, 1000 + (index * 400));
  });
}

function addAllSlotsToCart() {
  var items = [];
  for (var i = 1; i <= 3; i++) {
    var slotItem = document.getElementById('slot-item-' + i);
    if (slotItem) {
      var variantId = slotItem.getAttribute('data-variant-id');
      if (variantId) {
        items.push({
          id: parseInt(variantId),
          quantity: 1
        });
      }
    }
  }
  if (items.length === 0) return;
  
  var addAllBtn = document.getElementById('slot-add-all-btn');
  var originalText = addAllBtn ? addAllBtn.innerText : '';
  if (addAllBtn) {
    addAllBtn.disabled = true;
    addAllBtn.innerText = 'Aggiunta...';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(r) {
    if (!r.ok) throw new Error('Error adding items');
    return r.json();
  })
  .then(function(data) {
    if (typeof updateCartBadges === 'function') updateCartBadges();
    if (typeof toggleCartDrawer === 'function') toggleCartDrawer(true);
    if (addAllBtn) {
      addAllBtn.disabled = false;
      addAllBtn.innerText = 'Aggiunti!';
      setTimeout(function() {
        addAllBtn.innerText = originalText;
      }, 2000);
    }
  })
  .catch(function(err) {
    console.error('Error adding all slots to cart:', err);
    if (addAllBtn) {
      addAllBtn.disabled = false;
      addAllBtn.innerText = 'Errore!';
      setTimeout(function() {
        addAllBtn.innerText = originalText;
      }, 2000);
    }
  });
}

// === SHOPIFY FORMS STYLING (Shadow DOM & Light DOM) ===
function initShopifyFormsStyling() {
  var formsCss = `
    :host(shopify-forms-popup),
    shopify-forms-popup [class*="_formContainer_"],
    [data-sizing="form-wrapper"],
    ._formContainer_1q1d2_30 {
      font-family: var(--font-primary, 'Conduit ITC', -apple-system, BlinkMacSystemFont, sans-serif) !important;
      border-radius: 0px !important;
      border: 1px solid rgba(62, 58, 57, 0.15) !important;
      box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15) !important;
      background: #FFFFFF !important;
      color: #3E3A39 !important;
      --button-border-radius: 0px !important;
      --buttons-radius: 0px !important;
    }

    :host(shopify-forms-embed),
    shopify-forms-embed,
    shopify-forms-embed [class*="_formContainer_"] {
      font-family: var(--font-primary, 'Conduit ITC', -apple-system, BlinkMacSystemFont, sans-serif) !important;
      border-radius: 0px !important;
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
      color: #3E3A39 !important;
      width: 100% !important;
      --button-border-radius: 0px !important;
      --buttons-radius: 0px !important;
    }

    [class*="_textHeading_"],
    ._textHeading_2aowh_35,
    h2[class*="_textHeading_"] {
      font-family: var(--font-primary, 'Conduit ITC', -apple-system, BlinkMacSystemFont, sans-serif) !important;
      font-weight: 300 !important;
      text-transform: uppercase !important;
      letter-spacing: -0.01em !important;
      color: #3E3A39 !important;
      font-size: clamp(1.4rem, 2.5vw, 1.85rem) !important;
      line-height: 1.25 !important;
      margin-bottom: 8px !important;
    }

    [class*="_textBody_"],
    ._textBody_2aowh_10,
    [class*="_formHeader_"] p {
      font-family: var(--font-primary, 'Conduit ITC', -apple-system, BlinkMacSystemFont, sans-serif) !important;
      font-size: 14px !important;
      color: #666666 !important;
      line-height: 1.5 !important;
    }

    [class*="_formInputField_"],
    ._formInputField_nag3b_7,
    [data-testid="field-email"],
    input[type="text"],
    input[type="email"] {
      font-family: var(--font-primary, 'Conduit ITC', -apple-system, BlinkMacSystemFont, sans-serif) !important;
      font-size: 14px !important;
      color: #3E3A39 !important;
      border: 1px solid #3E3A39 !important;
      border-radius: 0px !important;
      background: #FFFFFF !important;
      padding: 10px 14px !important;
      box-sizing: border-box !important;
      outline: none !important;
      min-height: 44px !important;
    }
    [class*="_formInputField_"]:focus,
    input:focus {
      border-color: #000000 !important;
    }

    [class*="_formInputFieldLabel_"],
    ._formInputFieldLabel_1mxsl_38 {
      font-family: var(--font-primary, 'Conduit ITC', -apple-system, BlinkMacSystemFont, sans-serif) !important;
      font-size: 11px !important;
      text-transform: uppercase !important;
      letter-spacing: 0.08em !important;
      color: #777777 !important;
    }

    [class*="_checkboxInput_"],
    ._checkboxInput_1hja3_38,
    input[type="checkbox"] {
      accent-color: #3E3A39 !important;
      border-radius: 0px !important;
      cursor: pointer !important;
    }

    [class*="_consentCheckboxContainer_"] [class*="_textBody_"],
    [class*="_checkboxField_"] span {
      font-size: 11px !important;
      line-height: 1.4 !important;
      color: #777777 !important;
    }

    [data-testid="btn-form-submit"],
    [class*="_formSubmitButton_"],
    ._formSubmitButton_48bzm_124,
    button[type="submit"] {
      background-color: #3E3A39 !important;
      color: #FFFFFF !important;
      border: 1px solid #3E3A39 !important;
      border-radius: 0px !important;
      font-family: var(--font-primary, 'Conduit ITC', -apple-system, BlinkMacSystemFont, sans-serif) !important;
      font-weight: 700 !important;
      font-size: 12px !important;
      text-transform: uppercase !important;
      letter-spacing: 0.15em !important;
      min-height: 0px !important;
      padding-inline: 0px !important;
      width: 100% !important;
      cursor: pointer !important;
      transition: background-color 0.2s ease, border-color 0.2s ease !important;
    }
    [data-testid="btn-form-submit"]:hover,
    [class*="_formSubmitButton_"]:hover,
    button[type="submit"]:hover {
      background-color: #000000 !important;
      border-color: #000000 !important;
      color: #FFFFFF !important;
    }

    [class*="_formCloseButton_"],
    ._formCloseButton_1684x_4 {
      color: #3E3A39 !important;
      opacity: 0.7 !important;
      cursor: pointer !important;
      transition: opacity 0.2s ease !important;
    }
    [class*="_formCloseButton_"]:hover,
    ._formCloseButton_1684x_4:hover {
      opacity: 1 !important;
    }

    [class*="_formDisclaimer_"],
    ._formDisclaimer_48bzm_56 {
      font-family: var(--font-primary, 'Conduit ITC', -apple-system, BlinkMacSystemFont, sans-serif) !important;
      font-size: 11px !important;
      color: #888888 !important;
      margin-top: 14px !important;
      text-align: center !important;
    }
    [class*="_formDisclaimer_"] a,
    ._formDisclaimer_48bzm_56 a {
      color: #3E3A39 !important;
      text-decoration: underline !important;
    }
  `;

  var constructedSheet = null;
  try {
    if (typeof CSSStyleSheet !== 'undefined' && 'adoptedStyleSheets' in Document.prototype) {
      constructedSheet = new CSSStyleSheet();
      constructedSheet.replaceSync(formsCss);
    }
  } catch (e) {
    constructedSheet = null;
  }

  function injectShadowStyles(root) {
    if (!root) return;

    // Check if form elements have already rendered
    var hasFormContent = root.querySelector && (
      root.querySelector('form') ||
      root.querySelector('[class*="_formContainer_"]') ||
      root.querySelector('[data-sizing="form-wrapper"]') ||
      root.querySelector('input') ||
      root.querySelector('button')
    );

    // Clean up any orphan style tag previously inserted into an unhydrated shadow root
    var orphanStyle = root.querySelector && root.querySelector('style[data-qubi-forms-styles]');
    if (orphanStyle && !hasFormContent) {
      orphanStyle.remove();
    }

    // 1. Prefer adoptedStyleSheets: it applies rules without altering childNodes in the DOM tree,
    // thereby avoiding Preact/React hydration and reconciliation errors.
    if (constructedSheet && root.adoptedStyleSheets) {
      var isAdopted = false;
      for (var i = 0; i < root.adoptedStyleSheets.length; i++) {
        if (root.adoptedStyleSheets[i] === constructedSheet) {
          isAdopted = true;
          break;
        }
      }
      if (!isAdopted) {
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, constructedSheet];
      }
      return;
    }

    // 2. Fallback for environments without adoptedStyleSheets:
    // Only inject <style> AFTER form elements have been mounted to prevent crashing Preact hydration.
    if (!hasFormContent) {
      if (!root.__qubi_style_observer && window.MutationObserver) {
        root.__qubi_style_observer = new MutationObserver(function() {
          var ready = root.querySelector && (
            root.querySelector('form') ||
            root.querySelector('[class*="_formContainer_"]') ||
            root.querySelector('[data-sizing="form-wrapper"]') ||
            root.querySelector('input') ||
            root.querySelector('button')
          );
          if (ready) {
            root.__qubi_style_observer.disconnect();
            root.__qubi_style_observer = null;
            injectFallbackStyle(root);
          }
        });
        root.__qubi_style_observer.observe(root, { childList: true, subtree: true });
      }
      return;
    }

    injectFallbackStyle(root);
  }

  function injectFallbackStyle(root) {
    if (!root || (root.querySelector && root.querySelector('style[data-qubi-forms-styles]'))) return;
    var styleEl = document.createElement('style');
    styleEl.setAttribute('data-qubi-forms-styles', 'true');
    styleEl.textContent = formsCss;
    root.appendChild(styleEl);
  }

  function walkElement(el) {
    if (!el) return;
    if (el.shadowRoot) {
      injectShadowStyles(el.shadowRoot);
      var shadowChildren = el.shadowRoot.querySelectorAll('*');
      for (var i = 0; i < shadowChildren.length; i++) {
        walkElement(shadowChildren[i]);
      }
    }
  }

  function scanDOM() {
    var targets = document.querySelectorAll('shopify-forms-popup, shopify-forms-embed, shop-lead-capture, [data-sizing="form-wrapper"]');
    for (var i = 0; i < targets.length; i++) {
      walkElement(targets[i]);
    }
  }

  // Initial execution & polling for deferred script hydration
  scanDOM();
  if (document.readyState !== 'complete') {
    window.addEventListener('load', scanDOM);
  }

  // MutationObserver to catch dynamically injected popups and embeds
  if (window.MutationObserver) {
    var formsObserver = new MutationObserver(function(mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var addedNodes = mutations[m].addedNodes;
        for (var n = 0; n < addedNodes.length; n++) {
          if (addedNodes[n].nodeType === 1) {
            var node = addedNodes[n];
            if (node.shadowRoot || (node.matches && node.matches('shopify-forms-popup, shopify-forms-embed, shop-lead-capture, [data-sizing="form-wrapper"]'))) {
              walkElement(node);
            }
            if (node.querySelectorAll) {
              var subs = node.querySelectorAll('shopify-forms-popup, shopify-forms-embed, shop-lead-capture, [data-sizing="form-wrapper"]');
              for (var s = 0; s < subs.length; s++) {
                walkElement(subs[s]);
              }
            }
          }
        }
      }
    });
    formsObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
}

// === INIT ON DOM READY ===
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.product-card')) {
    initProductCardSliders();
  }
  initShopifyFormsStyling();
});
